import { connect } from 'react-redux';
import BrandConsolidation from './BrandConsolidationBanner';
import Cookie from './CookieBanner';

export const CookieBanner = connect(({ renderOptions: { showCookieBanner }}) => ({
  visible: showCookieBanner
}), null)(Cookie);

export const BrandConsolidationBanner = connect(({ system: { siteName, isMobile }, renderOptions: { showConsolidationBanner }}) => ({
  siteName, isMobile, showConsolidationBanner
}), null)(BrandConsolidation);
